import type { FunctionComponent } from 'react';
import { useId } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { Checkbox } from '~/ui/core/checkbox/Checkbox';

import { roleLabel, sortRoles } from './roles';

type RoleCheckboxGroupProps = {
    readonly label: string;
    readonly onChange: (roles: readonly string[]) => void;
    readonly roles: readonly string[];
    readonly value: readonly string[];
};

export const RoleCheckboxGroup: FunctionComponent<RoleCheckboxGroupProps> = ({ label, onChange, roles, value }) => {
    const translate = useTranslate();
    const id = useId();

    const toggle = (role: string, checked: boolean): void => {
        onChange(sortRoles(checked ? [...value, role] : value.filter((selected) => selected !== role)));
    };

    return (
        <fieldset className="flex flex-col gap-s">
            <legend className="mb-m text-body-s font-semibold text-text-secondary">{label}</legend>
            {sortRoles(roles).map((role) => (
                <div key={role} className="flex items-center gap-s">
                    <Checkbox
                        checked={value.includes(role)}
                        id={`${id}-${role}`}
                        onCheckedChange={(checked) => toggle(role, checked === true)}
                    />
                    <label className="text-body-s text-text-secondary" htmlFor={`${id}-${role}`}>
                        {roleLabel(translate, role)}
                    </label>
                </div>
            ))}
        </fieldset>
    );
};
